<div class="border-icon-button">
  <button mat-button
          color="primary"
          (click)="emitClick()"
          [disabled]="isDisabled()">
    <mat-icon>{{icon}}</mat-icon>
    <span>
      <ng-content></ng-content>
    </span>
  </button>
</div>
